<template lang="pug">
  .component-client-registration
    //Mr,Mrs,Ms,Miss
    form(v-on:submit.prevent='formSubmit')
      .row
        .small-12.large-3.columns
          label Client
            selectize-client(@optionSelected="selectClientId")
        .small-12.large-3.columns
          label Name &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'" required)
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.name')
        .small-12.large-2.columns
          label Surname &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'" required)
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.surname')
        .small-12.large-2.columns
          label Title
            select(v-model="body.title")
              option(value='Mr') Mr
              option(value='Mrs') Mrs
              option(value='Ms') Ms
              option(value='Miss') Miss
        .small-12.large-2.columns
          label Gender
            select(v-model="body.gender")
              option(value='-') -
              option(value='M') M
              option(value='F') F
      .row
        .small-12.large-4.columns
          label Mobile &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'" )
              span.fa.fa-star
            input(type='text', placeholder='international prefix call (ex: +39-3951231231)', v-model='body.mobile_phone' required)

        .small-12.large-3.columns
          label Email &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.email' required)
        .small-12.large-3.columns
          label Birthdate &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            date-picker(v-model='body.birthdate' required)
      .row
        h2 Residential address
      .row
        .columns
          label Street name &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'" )
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.street' required)
      .row
        .small-12.large-4.columns
          label City &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'" required)
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.city')
        .small-12.large-3.columns
          label Region &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'" required)
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.region')
        .small-12.large-3.columns
          label Country &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            selectize-country(@optionSelected="selectCountry")
        .small-12.large-2.columns
          label Postal code &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.postal_code')
      hr
      .row
        .small-12.large-4.large-offset-3.columns
          label Add document?
        .small-12.large-4.columns
          .switch.large
            input#add-document.switch-input(type='checkbox', v-model='document')
            label.switch-paddle(for='add-document')
              span.switch-active(aria-hidden='true') Yes
              span.switch-inactive(aria-hidden='true') No

      backoffice-driver-license-create(@driverLicenseUpdated="setDriverLicenseFields", v-if="document")
      .row
        .columns.text-center
          label
            input.button(type='submit')

</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import DatePicker from '../../components/structure/DatePicker'
import Dropzone from 'components/structure/Dropzone'
import BackofficeDriverLicenseCreate from './CreateDriverLicense'
import SelectizeClient from '../../components/structure/ui/lists/selectize/SelectizeClient'
import SelectizeCountry from '../../components/structure/ui/lists/selectize/SelectizeCountry'
import Tooltip from 'components/structure/foundation/Tooltip'

export default {
  name: 'BackofficeDriverCreate',
  components: {
    SelectizeCountry,
    SelectizeClient,
    BackofficeDriverLicenseCreate,
    DatePicker,
    Dropzone,
    Tooltip
  },
  data() {
    return {
      document: false,
      body: {
        client_id: null,
        name: null,
        title: null,
        surname: null,
        birthdate: null,
        gender: null,
        email: null,
        mobile_phone: null,
        address: {
          country: null,
          region: null,
          city: null,
          postal_code: null,
          street: null
        },
        accepted_tocs_id: []
      },

    }
  },
  computed: {},
  mounted() {

  },
  created() {
  },
  methods: {
    selectCountry(country) {
      this.body.address.country = country.name
    },
    selectLicenseCountry(id) {
      this.body.driver_license.issuer_country = id
    },
    selectClientId(client) {
      this.body.client_id = client.id
    },
    setDriverLicenseFields(driverLicense) {
      this.body.document = driverLicense
    },
    formSubmit() {
      if (this.document) {
        var propNames = Object.getOwnPropertyNames(this.body.document)
        for (var i = 0; i < propNames.length; i++) {
          var propName = propNames[i]
          if (this.body.document[propName] === '' || this.body.document[propName] === null || this.body.document[propName] === undefined) {
            delete this.body.document[propName]
          }
        }
      }else{
        delete this.body.document
      }

      KeplerBackofficeSdk.drivers.make(this.body, (data) => {
        this.$router.push({name: 'driver', params: {id: data.id}})
      })
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateDriver.vue?79cb0a9a